/**
 * Bouton de déconnexion.
 *
 * La purge locale a lieu même si l’appel serveur échoue (`fermerSession`) : le joueur ne doit
 * jamais rester affiché comme connecté alors que la session n’existe plus.
 */
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { fermerSession } from '../api';
import { Bouton } from './Bouton';

export function BoutonDeconnexion() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <Bouton
      variante="discret"
      onClick={() => {
        void fermerSession().finally(() => {
          navigate('/connexion', { replace: true });
        });
      }}
    >
      {t('accueil.deconnexion')}
    </Bouton>
  );
}
